<template>
	<div>
		<div class="d-flex align-center justify-end mb-2 mt-2 px-2">
			<div class="d-flex align-center" style="flex: 1;max-width: 400px;">
				<v-icon color="#524D4D" @click="searchForString">mdi-magnify</v-icon>
				<v-text-field
					v-model="searchInput"
					:loading="loadingList"
					outlined
					dense
					hide-details
					item-text="name"
					item-value="id"
					return-object
					clearable
					label="Búsqueda"
					class="mb-0 mr-2 custom-height-search custom-height-calendar"
					color="#524D4D"
					@input="sendToSearch"
				></v-text-field>
			</div>
			<DataTablePagination
				:options.sync="options"
				:item-length="client_preprojects_count"
				:loading-info="loadingList"
			/>
		</div>
    <v-data-table
			ref="table"
			:headers="headers"
			:items="client_preprojects"
			item-key="id"
			:loading="loadingList"
			:server-items-length="client_preprojects_count"
			:options.sync="options"
			loading-text="Cargando datos..."
			class="crm-table"
			:class="$vuetify.breakpoint.mobile ? '':'resizable'"
			disable-sort
			hide-default-footer
			@click:row="selectRow"
			:item-class="selectedRowClass"
			:footer-props="{
        itemsPerPageText: 'Filas por página'
			}"
    >
			<template v-slot:item.id="{ item }">
				<div>
					<div class="d-flex align-center">
						<p class="mb-1 mr-1 font-weight-bold">LP {{ item.project_line_info?.project_line?.number }}</p>
						<ProjectLineAssociationMenu :projectLineAssociations="item.associations" :btnClick="() => selectRow(item)"/>
					</div>
					<div class="d-flex align-center">
						<ProjectLineAssociationIcons :projectLineAssociations="item.associations" />
					</div>
				</div>
			</template>
      <template v-slot:item.company="{ item }">
				<p class="mb-0 caption">{{ item.company.name }}</p>
      </template>
      <template v-slot:item.name="{ item }">
				<p class="caption mb-0">{{ item.name }}</p>
      </template>
			<template v-slot:item.entity="{ item }">
				<div>
					<p class="caption mb-0">{{item.info?.address?.district?.name ?? '--'}}</p>
				</div>
			</template>
			<template v-slot:item.responsible="{ item }">
				<div>
					<p class="mb-0 caption">{{item.responsible?.profile?.name ?? '--'}}</p>
				</div>
			</template>
      <template v-slot:item.unarchive="{ item }">
				<div v-if="item.report_budgets?.length">
					<v-btn
						text
						dark
						x-small
						color="black"
						class="mb-1"
						@click.stop="() => { selectRow(item); openReportDetail && openReportDetail(getLastReportBudget(item).id); }"
					>
						<p class="font-weight-bold mb-0">{{getLastReportBudgetSerial(item)}}</p>
					</v-btn>


					<div class="d-flex justify-center align-center" v-if="getLastReportBudget(item)?.budget?.payment_order">
						<div>
							<v-chip
								:color="reportStatusColor(item)"
								label
								outlined
								x-small
								class="px-1 py-2"
							>
								<div class="d-flex align-center justify-space-between caption">
									<v-icon class="mr-1" x-small :color="reportStatusColor(item)">mdi-circle</v-icon>
									<b>{{reportStatusText(item)}}</b>
								</div>
							</v-chip>
						</div>
					</div>
					<v-tooltip bottom v-else>
						<template v-slot:activator="{ on, attrs }">
							<v-btn
								dark
								x-small
								color="success"
								class="mx-1 mb-2"
								@click.stop="() => { selectRow(item); startPaymentUnarchive(item); }"

								v-bind="attrs"
								v-on="on"
							>
								<div class="d-flex justify-center align-center">
									<v-icon small dark>mdi-credit-card-outline</v-icon>
									<p class="mb-0 ml-1">Pagar Desarchivo</p>
								</div>
							</v-btn>
						</template>
						<span>Pagar Desarchivo</span>
					</v-tooltip>
				</div>
				<div v-else>--</div>
			</template>
      <template v-slot:item.documents="{ item }">
				<p class="mb-0 caption">{{ item.documents.length == 0 ? '--':getDocumentDate(item) }}</p>
      </template>
      <template v-slot:item.status="{ item }">
				<v-chip
					class="mt-1"
					:color="getDocumentsStatus(item).color"
					x-small
					label
					dark
					v-if="getDocumentsStatus(item)"
				>
					{{getDocumentsStatus(item).label}}
				</v-chip>
      </template>
			<template v-slot:item.actions="{ item }">
				<v-tooltip bottom>
					<template v-slot:activator="{ on, attrs }">
						<v-btn
							class="mx-1"
							icon
							dark
							x-small
							color="primary"
							@click.stop="() => { selectRow(item); openPreProjectDetail(item.id); }"
							v-bind="attrs"
							v-on="on"
						>
							<v-icon small dark>mdi-eye</v-icon>
						</v-btn>
					</template>
					<span>Ver Detalle</span>
				</v-tooltip>
			</template>
    </v-data-table>
		<div class="d-flex align-center justify-end mt-2 px-2">
			<DataTablePagination
				:options.sync="options"
				:item-length="client_preprojects_count"
				:loading-info="loadingList"
			/>
		</div>
	</div>
</template>

<script>
import moment from 'moment'
import _debounce from 'lodash/debounce'
import { eventBus } from '@/components/Helpers/Events/NotificationsEventBus'
import DataTablePagination from '@/components/Helpers/Components/DataTablePagination'
import ProjectLineAssociationMenu from '@/components/Views/Projects/Parts/ProjectLineAssociationMenu'
import ProjectLineAssociationIcons from '@/components/Views/Projects/Parts/ProjectLineAssociationIcons'
import budgetStatuses from '@/components/Helpers/Constants/budget.js'

export default {
	name: 'ClientsPreProjectList',
	components: {
		DataTablePagination,
		ProjectLineAssociationMenu,
		ProjectLineAssociationIcons
	},
	props: {
		openReportDetail: {
      type: Function,
      required: false
    },
		clientId: {
      type: Number,
      required: true
    },
		openPreProjectDetail: {
      type: Function,
      required: true
    }
	},
	computed: {
		cities(){
			return this.$store.state.general.countryCities.filter(city => city.name.toLowerCase().includes(this.searchCity.toLowerCase()))
		},
		loadingList() {
			return this.$store.state.preprojects.loadingClientPreprojects
		},
		client_preprojects() {
			return this.$store.state.preprojects.clienPreprojects
		},
		client_preprojects_count() {
			return this.$store.state.preprojects.clienPreprojectsCount
		},
		selected_preproject() {
			return this.$route.query?.p
		}
	},
	watch: {
    options: {
      handler() {
				this.getClientPreProjects()
      },
      deep: true,
    }
	},
	data: () => ({
		budgetStatuses,
		selectedRowItem: null,
		searchCity: '',
		headers: [
			{ text: 'Línea de Proyecto', value: 'id', align: 'center', sortable: false },
			{ text: 'Empresa', value: 'company', align: 'center', sortable: false },
			{ text: 'Nombre Proyecto', value: 'name', align: 'center', sortable: false },
			{ text: 'Municipalidad', value: 'entity', align: 'center', sortable: false },
			{ text: 'P. Desarchivo', value: 'unarchive', width: '140px', align: 'center', sortable: false },
			{ text: 'Fecha Solicitud Desarchivo', value: 'documents', align: 'center', sortable: false },
			{ text: 'Profesional Encargado', value: 'responsible', align: 'center', sortable: false },
			{ text: 'Estado Antecedentes', value: 'status', align: 'center', sortable: false },
			{ text: 'Acciones', value: 'actions', sortable: false },
		],
		searchInput: null,
		options: {
			page: 1,
			itemsPerPage: 10,
			sortBy: [],
			sortDesc: [],
		},
	}),
	mounted(){
		this.getClientPreProjects()
		const preproject_id = this.$route.query.p
		if(preproject_id){
			this.selectedRowItem = preproject_id
			this.openPreProjectDetail(preproject_id)
		}
		else{
			const selectedRow = JSON.parse(localStorage.getItem('selected_clients_preproject_row'));
			if (selectedRow) {
				this.selectedRowItem = selectedRow
			}
		}
		this.$store.dispatch('users/getUserFromCompany')
    eventBus.$on('reloadInformation', this.getClientPreProjects)
	},
	beforeDestroy() {
		eventBus.$off('reloadInformation', this.getClientPreProjects)
	},
	methods: {
		startPaymentUnarchive(item){
			const last = this.getLastReportBudget(item)
			if(last && last.budget?.id){
				const url = 'https://apiarq.insomnia.cl/report-budget-confirm?rb=' + last.budget?.id;
				window.open(url, '_blank').focus();
			}
		},
		getLastReportBudget(item){
			const sorted = [...item.report_budgets].sort((a, b) => b.id - a.id);
			const last = sorted[0];
			return last
		},
		reportStatusText(report){
			const sorted = [...report.report_budgets].sort((a, b) => b.id - a.id);
			const last = sorted[0];
			const reportStatus = last.last_status?.status
			return this.$options.filters.budgetStatus(reportStatus)
		},
		reportStatusColor(report){
			const sorted = [...report.report_budgets].sort((a, b) => b.id - a.id);
			const last = sorted[0];
			const reportStatus = last.last_status?.status
			return this.$options.filters.budgetStatusColor(reportStatus)
		},
		getLastReportBudgetSerial(item) {
			if (!item.report_budgets || item.report_budgets.length === 0) {
				return null;
			}
			const sorted = [...item.report_budgets].sort((a, b) => b.id - a.id);
			const last = sorted[0];

			const year = new Date(last.created_at).getFullYear();

			const serial =
				`${item.project_line_info?.id || ''} - ` +
				`${last.prefix?.prefix || ''} ` +
				`${last.serial?.serial || ''} - ` +
				`${year}` +
				`${last.report_index > 1 ? ' - #' + last.report_index : ''}`;

			return serial.trim();
		},
		selectRow(item){
			this.selectedRowItem = item.id
			localStorage.setItem('selected_clients_preproject_row', JSON.stringify(item.id))
		},
		selectedRowClass(item){
			if (this.selectedRowItem && this.selectedRowItem === item.id) {
				return 'selected-row-custom-item';
			}
			return ''
		},
		sendToSearch: _debounce(function() { this.searchForString() }, 800),
		searchForString(){
			this.options = {...this.options, ...{page: 1}}
			this.getClientPreProjects()
		},
		getRowClass(item) {
			return item.id == this.selected_preproject ? 'custom-client-highlight-row' : '';
		},
		async getClientPreProjects(){
			let data = {
				...this.options,
				client_id: this.clientId,
				start: (this.options.page - 1) * this.options.itemsPerPage,
				limit: this.options.itemsPerPage,
			}
			if(this.searchInput){
				data = {...data, ...{search: this.searchInput}}
			}
			this.$store.dispatch('preprojects/getClientPreProjects', data)
		},
		getDocumentDate(item){
			return this.$options.filters.toDateTime( item.documents.reduce((min, obj) => obj.created_at < min ? obj.created_at : min, item.documents[0].created_at) )
		},
		getDocumentsStatus(item){
			if(item.documents.length == 0) return {label: 'Creado', color: '#959595'}
			const all_delivered = item.documents.every((document) => document.delivered_date)
			const some_delayed = item.documents.some((document) => !document.delivered_date && document.max_date && moment().isAfter(document.max_date))
			if(all_delivered){
				return {label: 'Entregado', color: 'green'}
			}
			else if (some_delayed){
				return {label: 'Atrasados', color: 'red'}
			}
			return {label: 'Solicitados', color: 'orange'}
		}
	}
}
</script>

<style scoped>
	.menu-bg-white{background: white;}
</style>

<style>
.custom-client-highlight-row {
  background-color: #e8e8e8 !important;
}
</style>